module.exports = __webpack_public_path__ + "img/TORTAS.4ecb0453.png";